// Where a project stands, in plain words, for the overview and the menu.
import { day, fmtDate, type Entry } from "./api"
import { t } from "./i18n"

export function projectSpan(e: Entry) {
    const ph = e.project.planning.phases
    return { start: Math.min(...ph.map((p) => day(p.start))), end: Math.max(...ph.map((p) => day(p.end))) + 43200000 }
}

/** 0..1: how far the planning has got today */
export function progress(e: Entry, now = Date.now()) {
    const { start, end } = projectSpan(e)
    return Math.min(1, Math.max(0, (now - start) / (end - start)))
}

export function status(e: Entry, now = Date.now()): { text: string; tone: "act" | "now" | "done" | "next" } {
    if (!e.approval) return { text: t("Estimate to approve"), tone: "act" }
    const { start, end } = projectSpan(e)
    if (now < start) return { text: t("Starts {date}", { date: fmtDate(e.project.planning.phases[0].start) }), tone: "next" }
    if (now > end) return { text: t("Finished"), tone: "done" }
    const current = e.project.planning.phases.find((p) => now >= day(p.start) && now <= day(p.end) + 43200000)
    return { text: current ? t("{phase}, in progress", { phase: current.name }) : t("In progress"), tone: "now" }
}
